import { Vertical } from 'component/Vertical'
import { Notice } from 'feature/notice/Notice'
import { observer } from 'mobx-react-lite'
import { createPortal } from 'react-dom'
import { notice } from './NoticeController'
import css from './Notices.module.scss'

export const Notices = observer(() => {
  const { notices } = notice

  const content = <Vertical className={css.notices} center>
    {notices.map(notice => <Notice key={notice.key} notice={notice} />)}
  </Vertical>

  return createPortal(content, document.body)
})
